"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("@components/common");
const Icon_1 = __importDefault(require("@components/icons/Icon"));
const search_svg_1 = __importDefault(require("@components/icons/search.svg"));
const StyledInput = styled_components_1.default.input `
  border: 1px solid #ccc;
  border-radius: 50px;
  height: 50px;
  width: ${props => props.width || '100%'};
  max-width: 800px;
  padding: 0 20px 0 40px;
  &:focus, &:active {
    outline: none;
  }
  font-size: 16px;
`;
const StyledSearchIcon = (0, styled_components_1.default)(Icon_1.default) `
  position: absolute;
  left: 20px;
  top: calc(50% - 7px);
  width: 15px;
  height: 15px;
  display: flex;
`;
// eslint-disable-next-line react/prop-types
const Search = ({ onSearch, t }) => {
    const handleChange = (0, react_1.useCallback)((ev) => {
        const { value } = ev.target;
        onSearch({ value });
    }, [onSearch]);
    return react_1.default.createElement(common_1.Box, { style: { position: 'relative' }, width: "100%" },
        react_1.default.createElement(StyledSearchIcon, { url: search_svg_1.default, alt: "" }),
        react_1.default.createElement(StyledInput, { placeholder: t.searchPlaceholder, onChange: handleChange }));
};
exports.default = Search;
